export { default } from './ClosingDocumentsSection';
